import React, { useEffect, useRef } from 'react';
import instantsearch from 'instantsearch.js';
import { searchBox, hits, pagination } from 'instantsearch.js/es/widgets';
import TypesenseInstantSearchAdapter from 'typesense-instantsearch-adapter';
import styles from './BrowseTest.module.scss';
import config from '../../config';
import { Search } from 'lucide-react';

const BrowseTest = () => {
  const searchContainerRef = useRef(null);
  const hitsContainerRef = useRef(null);
  const paginationContainerRef = useRef(null);
  const searchInstanceRef = useRef(null);

  useEffect(() => {
    console.log('config.typesense', config.typesense);
    const typesenseInstantsearchAdapter = new TypesenseInstantSearchAdapter({
      server: {
        apiKey: config.typesense.apiKeySearchOnly,
        nodes: [{ url: config.typesense.endpoint }],
      },
      additionalSearchParameters: {
        query_by: 'displayname,bio,location.text',
      },
    });

    const searchClient = typesenseInstantsearchAdapter.searchClient;

    const search = instantsearch({
      indexName: 'users_search',
      searchClient,
    });

    search.addWidgets([
      searchBox({
        container: searchContainerRef.current,
        placeholder: 'Search across 1M+ Experts',
        showReset: true,
        showSubmit: false,
        showLoadingIndicator: false,
        cssClasses: {
          root: styles.searchBoxRoot,
          form: styles.searchBoxForm,
          input: styles.searchBoxInput,
        },
      }),

      hits({
        container: hitsContainerRef.current,
        cssClasses: {
          root: styles.hitsRoot,
          list: styles.hitsList,
          item: styles.hitsItem,
          emptyRoot: styles.noResults,
        },
        templates: {
          item: (hit) => `
            <div class="${styles.userCard}">
              <div class="${styles.userCardBody}">
                <div class="${styles.userCardHeader}">
                  <span class="${styles.displayName}">
                    ${hit.displayname || 'No name'}
                  </span>
                </div>
                ${
                  hit.location?.text
                    ? `<p class="${styles.location}">${hit.location.text}</p>`
                    : ''
                }
                ${hit.bio ? `<p class="${styles.bio}">${hit.bio}</p>` : ''}
              </div>
            </div>
          `,
          empty: `<div class="${styles.noResults}">No results found. Try a different search.</div>`,
        },
      }),

      pagination({
        container: paginationContainerRef.current,
        cssClasses: {
          root: styles.paginationRoot,
          list: styles.paginationList,
          item: styles.paginationItem,
          link: styles.paginationLink,
          selectedItem: styles.paginationItemSelected,
          disabledItem: styles.paginationItemDisabled,
        },
      }),
    ]);

    search.start();
    searchInstanceRef.current = search;

    return () => {
      if (searchInstanceRef.current) {
        searchInstanceRef.current.dispose();
      }
    };
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.heading}>Browse</h1>

        <div className={styles.searchWrapper}>
          <span className={styles.searchIcon}>
            <Search size={18} />
          </span>
          <div ref={searchContainerRef} className={styles.searchBoxContainer} />
        </div>

        <div ref={hitsContainerRef} className={styles.resultsContainer} />
        <div
          ref={paginationContainerRef}
          className={styles.paginationContainer}
        />
      </div>
    </div>
  );
};

export default BrowseTest;
